import { CreditRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";
import { CreditDataType } from "@utilities/types";

export const creditServices = {

    creditPayment: async (creditID: string, creditData: CreditDataType) => {
        return await fetchRequest({
            route: `${CreditRoutesEnum.CREDIT_PAYMENT}/${creditID}`,
            method: "PUT",
            data: { ...creditData }
        });
    },

    getAllOrganisationCredits: async (organisationID: string) => {
        return await fetchRequest({
            route: `${CreditRoutesEnum.CREDIT_GET_ALL}/${organisationID}`,
            method: "GET"
        });
    },

    getClosedCredits: async (organisationID: string) => {
        return await fetchRequest({
            route: `${CreditRoutesEnum.CREDIT_GET_CLOSED}/${organisationID}`,
            method: "GET"
        });
    },

};
